import React, {useEffect} from "react";
import {Card} from "antd";
import SearchForm from "./SearchForm";
import PoList from "./PoList";
import {useModelDispatchers} from "../../../models/index";

export default function () {
    const {getPurchaseStatusDict, getInvoiceTypeDict, getSupplierDict} = useModelDispatchers("cmDict");

    useEffect(() => {
        getPurchaseStatusDict();
        getInvoiceTypeDict();
        getSupplierDict();
    }, []);

    return (
        <>
            <Card
                bordered={true}
                className="margin-top-8"
                style={{display: "flex"}}
            >
                <div
                    style={{
                        margin: "8px 20px"
                    }}
                >
                    <SearchForm/>
                </div>
            </Card>
            <Card
                bordered={true}
                className="margin-top-8"
            >
                <PoList/>
            </Card>
        </>
    )
}